export default "__VITE_ASSET__B1Fw06gq__"